var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500183 15.9999C0.500183 7.44408 7.44427 0.5 16.0001 0.5C24.5558 0.5 31.4999 7.44408 31.4999 15.9999C31.4999 24.5557 24.5558 31.4997 16.0001 31.4997C7.44427 31.4997 0.500183 24.5557 0.500183 15.9999Z",
    fill: "white",
    stroke: "#C9D1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3126 23.8782H14.6865V21.2522H17.3126V23.8782Z",
    fill: "#C9D1CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3126 23.8782H14.6865V21.2522H17.3126V23.8782Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7474 13.374C10.7474 10.4722 13.0978 8.12183 15.9996 8.12183C18.9014 8.12183 21.2517 10.4722 21.2517 13.374C21.2517 16.6565 17.3126 16.9848 17.3126 19.9391H14.6865C14.6865 15.6718 18.6256 16 18.6256 13.374C18.6256 11.9296 17.4439 10.7479 15.9996 10.7479C14.5552 10.7479 13.3735 11.9296 13.3735 13.374H10.7474Z",
    fill: "#C9D1CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7474 13.374C10.7474 10.4722 13.0978 8.12183 15.9996 8.12183C18.9014 8.12183 21.2517 10.4722 21.2517 13.374C21.2517 16.6565 17.3126 16.9848 17.3126 19.9391H14.6865C14.6865 15.6718 18.6256 16 18.6256 13.374C18.6256 11.9296 17.4439 10.7479 15.9996 10.7479C14.5552 10.7479 13.3735 11.9296 13.3735 13.374H10.7474Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.0b1c6b0312edce30f6df192ed7452b1d.svg";
export { ForwardRef as ReactComponent };